export default __webpack_public_path__ + "static/media/drizzle-day.b2ba259d.svg";